var moduleMap = {
	"./UserStore.ts": function() {
		return Promise.all([__webpack_require__.e(4080), __webpack_require__.e(344), __webpack_require__.e(7167), __webpack_require__.e(4222), __webpack_require__.e(9827)]).then(function() { return function() { return (__webpack_require__(98942)); }; });
	},
	"./WebsocketStore.ts": function() {
		return Promise.all([__webpack_require__.e(4080), __webpack_require__.e(344), __webpack_require__.e(7167), __webpack_require__.e(4222), __webpack_require__.e(5179), __webpack_require__.e(9338)]).then(function() { return function() { return (__webpack_require__(89338)); }; });
	},
	"./ClientStore.ts": function() {
		return Promise.all([__webpack_require__.e(4080), __webpack_require__.e(344), __webpack_require__.e(7167), __webpack_require__.e(4222), __webpack_require__.e(9827)]).then(function() { return function() { return (__webpack_require__(12808)); }; });
	},
	"./ThumbnailStore.js": function() {
		return Promise.all([__webpack_require__.e(4080), __webpack_require__.e(344), __webpack_require__.e(7167), __webpack_require__.e(4222), __webpack_require__.e(1420)]).then(function() { return function() { return (__webpack_require__(21420)); }; });
	},
	"./ServiceDownloadsStore.js": function() {
		return Promise.all([__webpack_require__.e(4080), __webpack_require__.e(344), __webpack_require__.e(7167), __webpack_require__.e(4222), __webpack_require__.e(2058)]).then(function() { return function() { return (__webpack_require__(12058)); }; });
	},
	"./AssetStore.ts": function() {
		return Promise.all([__webpack_require__.e(4080), __webpack_require__.e(344), __webpack_require__.e(7167), __webpack_require__.e(8626), __webpack_require__.e(4222), __webpack_require__.e(3037), __webpack_require__.e(1405)]).then(function() { return function() { return (__webpack_require__(12239)); }; });
	},
	"./axios.ts": function() {
		return Promise.all([__webpack_require__.e(4080), __webpack_require__.e(344), __webpack_require__.e(7167), __webpack_require__.e(4222), __webpack_require__.e(9827)]).then(function() { return function() { return (__webpack_require__(39827)); }; });
	},
	"./useCpaPermissionCheck.js": function() {
		return Promise.all([__webpack_require__.e(4080), __webpack_require__.e(344), __webpack_require__.e(7167), __webpack_require__.e(4222), __webpack_require__.e(6512)]).then(function() { return function() { return (__webpack_require__(96512)); }; });
	},
	"./MultipartUpload.vue": function() {
		return Promise.all([__webpack_require__.e(5395), __webpack_require__.e(4080), __webpack_require__.e(344), __webpack_require__.e(381), __webpack_require__.e(7167), __webpack_require__.e(2184), __webpack_require__.e(4222), __webpack_require__.e(3771), __webpack_require__.e(1824)]).then(function() { return function() { return (__webpack_require__(81824)); }; });
	},
	"./DynamicMultipartUpload.vue": function() {
		return Promise.all([__webpack_require__.e(5395), __webpack_require__.e(4080), __webpack_require__.e(344), __webpack_require__.e(381), __webpack_require__.e(7167), __webpack_require__.e(4222), __webpack_require__.e(1455), __webpack_require__.e(3771), __webpack_require__.e(9411)]).then(function() { return function() { return (__webpack_require__(62335)); }; });
	},
	"./useThemeManager.ts": function() {
		return __webpack_require__.e(2947).then(function() { return function() { return (__webpack_require__(22947)); }; });
	},
	"./useNoty.ts": function() {
		return Promise.all([__webpack_require__.e(4080), __webpack_require__.e(4291)]).then(function() { return function() { return (__webpack_require__(4291)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});